import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TypeEditorWidgetV2: WidgetRegistryEntry = {
  name: "TypeEditorV2",
  component: () => import("./type-editor-widget-v2.component").then((m) => m.TypeEditorWidgetV2Component),
  configuration: () => import("./configuration").then((m) => m.TypeEditorWidgetV2Configuration)
};
